import type { OutputModelParsingError, OutputModelParsingErrorMessageMap } from ".";
import { OUTPUT_MODEL_PARSING_ERROR } from ".";
import t from "../../../../i18n";
import { FILE_PARSING_ERROR } from "../../common/file";

/**
 * @description Error messages that can be presented to the user by the observable parser.
 */
const OutputModelErrorMessages: OutputModelParsingErrorMessageMap = {
  [FILE_PARSING_ERROR.FILE_EMPTY]: () =>
    t("setup.diagnosis.observable.import_observables.error.empty_file"),
  [FILE_PARSING_ERROR.FILE_SIZE_LIMIT_EXCEEDED]: () =>
    t("setup.diagnosis.observable.import_observables.error.file_size_limit_exceeded"),
  [FILE_PARSING_ERROR.FILE_INVALID_TYPE]: () =>
    t("setup.simulation.output_model.error.file_invalid_type"),
  [OUTPUT_MODEL_PARSING_ERROR.FILE_INVALID_CONTENT]: () =>
    t("setup.simulation.output_model.error.file_invalid_content"),
  [OUTPUT_MODEL_PARSING_ERROR.DATA_QUANTITY_NAME_EMPTY]: () =>
    t("setup.simulation.input_model.error.name.empty"),
  [OUTPUT_MODEL_PARSING_ERROR.DATA_QUANTITY_DUPLICATED]: errorData =>
    t("setup.simulation.output_model.error.data_quantity_duplicated", errorData.value || ""),
  [OUTPUT_MODEL_PARSING_ERROR.DATA_FILE_EMPTY]: () =>
    t("setup.simulation.output_model.import.error.data_file_empty"),
  [OUTPUT_MODEL_PARSING_ERROR.DATA_QUANTITY_NAME_NOT_ALLOWED]: errorData =>
    t(
      "setup.simulation.output_model.import.error.data_quantity_name_not_allowed",
      errorData.value || "",
    ),
  [OUTPUT_MODEL_PARSING_ERROR.DATA_OFFSET_EXPECTED_INVALID]: errorData =>
    t(
      "setup.simulation.output_model.import.error.data_offset_expected_invalid",
      errorData.value || "",
    ),
  [OUTPUT_MODEL_PARSING_ERROR.DATA_OUTPUT_MODEL_INVALID_DEFINITION]: errorData =>
    t(
      "setup.simulation.output_model.import.error.data_output_model_invalid_definition",
      errorData.value || "",
    ),
  [OUTPUT_MODEL_PARSING_ERROR.DATA_OFFSET_EXPECTED_INVALID_DEFINITION]: errorData =>
    t(
      "setup.simulation.output_model.import.error.data_offset_expected_invalid_definition",
      errorData.value || "",
    ),
  [OUTPUT_MODEL_PARSING_ERROR.DATA_OUTPUT_MODEL_NAME_TOO_LONG]: errorData =>
    t("setup.quantity.import.error.data_output_model_name_too_long", errorData.value || ""),
};

/**
 * @description Get error message from error kind.
 * @param error OutputModelParsingError
 * @returns Translated error message.
 */
export const getOutputModelParsingErrorMessage = (error: OutputModelParsingError) => {
  const errorMessage = OutputModelErrorMessages[error.kind];
  return errorMessage ? errorMessage(error.data) : "Unknown error";
};
